export default [
  {
    title: 'Requests',
    icon: { icon: 'mdi-handshake-outline' },
    children: [
      {
        title: 'Current Requests',
        icon: { icon: 'mdi-cog-clockwise' },
        to: 'm',
        action: 'read',
        subject: 'Auth',
      },
      {
        title: 'Past Requests',
        icon: { icon: 'mdi-clock-check-outline' },
        to: 'past-requests',
        action: 'read',
        subject: 'Auth',
      }
    ],
  },
  {
    title: 'Restaurants',
    icon: { icon: 'mdi-silverware-fork-knife' },
    children: [
      {
        title: 'All Restaurants',
        icon: { icon: 'mdi-silverware-fork-knife' },
        to: 'all-restaurants',
        action: 'read',
        subject: 'Auth',
      },
      {
        title: 'Nav Levels',
        icon: { icon: 'mdi-menu' },
        children: [
          {
            title: 'Level 2.1',
            to: null,
          },
          {
            title: 'Level 2.2',
            children: [
              {
                title: 'Level 3.1',
                to: null,
              },
              {
                title: 'Level 3.2',
                to: null,
              },
            ],
          },
        ],
      },
      {
        title: 'Disabled Menu',
        to: null,
        icon: { icon: 'mdi-eye-off-outline' },
        disable: true,
      },
      {
        title: 'Raise Support',
        href: 'https://themeselection.com/support/',
        icon: { icon: 'mdi-lifebuoy' },
        target: '_blank',
      },
      {
        title: 'Documentation',
        href: 'https://demos.themeselection.com/materio-vuetify-vuejs-admin-template/documentation/',
        icon: { icon: 'mdi-file-document-outline' },
        target: '_blank',
      },
    ],
  },
]
